import { createApi } from '@reduxjs/toolkit/query/react';
import {
  EventSector,
  CreateEventSectorDTO,
  UpdateEventSectorDTO,
} from '../../models/ticket';
import { Response } from '../../models/shared';
import baseQueryWithReauth from './base';

const eventSectorsApi = createApi({
  reducerPath: 'eventSectorsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['event_sectors', 'event_seats_raw'],
  endpoints: (build) => ({
    getEventSectors: build.query<EventSector[], { eventId: string }>({
      providesTags: (result, error, { eventId }) => [{ type: 'event_sectors', id: eventId }, 'event_sectors'],
      query: ({ eventId }) => ({
        url: `/events/${eventId}/sectors`,
        method: 'GET',
      }),
      transformResponse: (response: Response<EventSector[]>): EventSector[] => response.data || [],
    }),
    createEventSector: build.mutation<EventSector | null, { eventId: string; body: CreateEventSectorDTO }>({
      query: ({ eventId, body }) => ({
        url: `/events/${eventId}/sectors`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['event_sectors', 'event_seats_raw'],
      transformResponse: (response: Response<EventSector>): EventSector | null => response.data || null,
    }),
    updateEventSector: build.mutation<EventSector | null, { eventId: string; sectorId: string; body: UpdateEventSectorDTO }>({
      query: ({ eventId, sectorId, body }) => ({
        url: `/events/${eventId}/sectors/${sectorId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['event_sectors', 'event_seats_raw'],
      transformResponse: (response: Response<EventSector>): EventSector | null => response.data || null,
    }),
    deleteEventSector: build.mutation<void, { eventId: string; sectorId: string }>({
      query: ({ eventId, sectorId }) => ({
        url: `/events/${eventId}/sectors/${sectorId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['event_sectors', 'event_seats_raw'],
    }),
  }),
});

export const {
  useGetEventSectorsQuery,
  useCreateEventSectorMutation,
  useUpdateEventSectorMutation,
  useDeleteEventSectorMutation,
} = eventSectorsApi;
export { eventSectorsApi };
